import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import getOppLinks from 'routes/getOppLinks';
import { env } from 'utils/env';
import { isProd, isDemo, Environment, isTest } from 'utils/environments';
import { useNestedTranslation } from './useNestedTranslation';

const hoursBudgetingId = 5;

const useOpp = () => {
    const [searchParams] = useSearchParams();
    const t = useNestedTranslation('oppLinks');
    const isOpp = searchParams.get('opp') === 'true';
    const versionString = searchParams.get('version');
    const version = versionString ? Number.parseInt(versionString, 10) : 1;
    const oppHomeUrl = env[`VITE_APP_URLS_opp_home_v${version}_url`];

    const environment = useMemo(() => {
        if (isProd) return Environment.PROD;
        if (isDemo) return Environment.DEMO;
        if (isTest) return Environment.TEST;

        return Environment.DEV;
    }, []);

    const availableApps = useMemo(() => {
        const links = getOppLinks({ env: environment, t });

        return links.filter(link => link.version === version);
    }, [environment, version, t]);

    const hoursBudgeting = useMemo(() => availableApps.find(app => app.id === hoursBudgetingId), [availableApps]);

    return { isOpp, version, oppHomeUrl, availableApps, hoursBudgeting };
};

export default useOpp;
